import React from 'react';
import {View} from 'react-native';
import {Button, makeStyles} from '@rneui/themed';
import {
  faCaretRight,
  faBagShopping,
  faTruck,
} from '@fortawesome/free-solid-svg-icons';

import Text from '../themed/Text';
import PressableWithOpacityFeedback from '../ui-controls/PressableWithOpacityFeedback';
import {FontAwesomeIcon} from '@fortawesome/react-native-fontawesome';

type StoreNameCardProps = {
  storeName: string;
  canDeliver?: boolean;
  canPickup?: boolean;
  onStoreNamePress?: any;
};

/**
 * Used on cart screen
 */
function StoreNameCard({
  storeName,
  onStoreNamePress,
  canDeliver,
  canPickup,
}: StoreNameCardProps) {
  const styles = useStyles();

  return (
    <View style={[styles.containerStyle]}>
      <View style={[styles.wrapperStyle]}>
        <PressableWithOpacityFeedback
          onPress={onStoreNamePress}
          style={styles.storeContainerStyle}>
          <Text style={[styles.textStyle]}>{storeName}</Text>
          <FontAwesomeIcon
            icon={faCaretRight}
            size={16}
            color={styles.textStyle.color}
          />
        </PressableWithOpacityFeedback>
        <View style={styles.methodsContainerStyle}>
          <Button
            activeOpacity={1}
            disabled={!canPickup}
            icon={
              <FontAwesomeIcon
                style={{marginRight: 6}}
                icon={faBagShopping}
                size={10}
                color={
                  canPickup
                    ? styles.textStyle.color
                    : styles.disabledTitleStyle.color
                }
              />
            }
            disabledStyle={styles.disabledStyle}
            disabledTitleStyle={styles.disabledTitleStyle}
            buttonStyle={styles.chipButtonStyle}>
            <Text
              variant="body2"
              style={canPickup ? styles.textStyle : styles.disabledTitleStyle}>
              Pick up
            </Text>
          </Button>
          <Button
            activeOpacity={1}
            disabled={!canDeliver}
            icon={
              <FontAwesomeIcon
                style={{marginRight: 6}}
                icon={faTruck}
                size={13}
                color={
                  canDeliver
                    ? styles.textStyle.color
                    : styles.disabledTitleStyle.color
                }
              />
            }
            disabledStyle={styles.disabledStyle}
            disabledTitleStyle={styles.disabledTitleStyle}
            buttonStyle={styles.chipButtonStyle}>
            <Text
              variant="body2"
              style={canDeliver ? styles.textStyle : styles.disabledTitleStyle}>
              Delivery
            </Text>
          </Button>
        </View>
      </View>
    </View>
  );
}

const useStyles = makeStyles(theme => {
  return {
    containerStyle: {
      maxWidth: 1320,
      width: '100%',
      alignSelf: 'center',
    },
    wrapperStyle: {
      padding: 20,
      margin: 16,
      backgroundColor: theme.colors.primaryDarker,
      borderRadius: 10,
      alignItems: 'flex-start',
    },
    storeContainerStyle: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 16,
    },
    textStyle: {
      fontWeight: '600',
      color:
        theme.colors?.legacy?.icon?.header?.secondary ||
        theme.colors?.legacy?.icon?.header?.primary,
    },
    disabledStyle: {
      backgroundColor: theme.colors.primaryDarker,
    },
    disabledTitleStyle: {
      color: theme.colors.grey4,
    },
    chipButtonStyle: {
      backgroundColor: theme.colors.primaryDarkest,
      borderRadius: 5,
    },
    methodsContainerStyle: {
      flexDirection: 'row',
      gap: 10,
      marginTop: 16,
    },
  };
});

export default StoreNameCard;
